import React from "react";
import Header from "../../components/Header";

class HeaderContainer extends React.Component {

    render() {
        return (
            <div>
                <Header title={'KALKULATORY'}/>
            </div>
        )
    }
}

export default HeaderContainer;